import { render, staticRenderFns } from "./UITeamPortfolioProfilesTable.vue?vue&type=template&id=69ec3ca2"
import script from "./UITeamPortfolioProfilesTable.vue?vue&type=script&lang=js"
export * from "./UITeamPortfolioProfilesTable.vue?vue&type=script&lang=js"
import style0 from "./UITeamPortfolioProfilesTable.vue?vue&type=style&index=0&id=69ec3ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
